import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type { CurrentPageState } from './types';

const initialStateCurrentPage: CurrentPageState = '';

export const currentPageSlice = createSlice({
    name: 'currentPage',
    initialState: initialStateCurrentPage,
    reducers: {
        setCurrentPage: (
            state: CurrentPageState,
            action: PayloadAction<CurrentPageState>
        ): CurrentPageState => {
            return action.payload;
        },
        resetCurrentPage: (): CurrentPageState => {
            return initialStateCurrentPage;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return initialStateCurrentPage;
        });
    }
});

export const { setCurrentPage, resetCurrentPage } = currentPageSlice.actions;

export const selectCurrentPage = (state: RootState): CurrentPageState =>
    state.currentPage;

export default currentPageSlice.reducer;
